import { render, staticRenderFns } from "./FormText.vue?vue&type=template&id=6ad02074&"
import script from "./FormText.vue?vue&type=script&lang=js&"
export * from "./FormText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad02074')) {
      api.createRecord('6ad02074', component.options)
    } else {
      api.reload('6ad02074', component.options)
    }
    module.hot.accept("./FormText.vue?vue&type=template&id=6ad02074&", function () {
      api.rerender('6ad02074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/form-v1/FormText.vue"
export default component.exports